import { render, staticRenderFns } from "./ulanqab.vue?vue&type=template&id=2d5e06ae&scoped=true"
import script from "./ulanqab.vue?vue&type=script&lang=js"
export * from "./ulanqab.vue?vue&type=script&lang=js"
import style0 from "./ulanqab.vue?vue&type=style&index=0&id=2d5e06ae&prod&lang=less&scoped=true"
import style1 from "./ulanqab.vue?vue&type=style&index=1&id=2d5e06ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e06ae",
  null
  
)

export default component.exports